import { Box, Text, chakra } from "@chakra-ui/react";

const FormContainer = chakra(Box, {
  baseStyle: {
    width: { base: "full", md: "520px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "24px",
  },
});

const ResetSuccessTopHeading = chakra(Text, {
  baseStyle: {
    display: "flex",
    fontWeight: "700",
    fontSize: { base: "24px", md: "28.42px" },
    marginTop: { base: "16px", md: "20px" },
    textAlign: "center",
  },
});
const ResetSuccessHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
    marginTop: { base: "12px", md: "18px" },
    textAlign: "center",
    px: { base: "12px", md: "32px" },
  },
});

export { FormContainer, ResetSuccessTopHeading, ResetSuccessHeading };
